import request from './request';

const documentRequirementService = {
  getAll: (params) =>
    request.get('dashboard/admin/document-requirements', { params }),
  getById: (id) => request.get(`dashboard/admin/document-requirements/${id}`),
  create: (data) => request.post('dashboard/admin/document-requirements', data),
  update: (id, data) =>
    request.put(`dashboard/admin/document-requirements/${id}`, data),
  delete: (id) => request.delete(`dashboard/admin/document-requirements/${id}`),
};

export default documentRequirementService;
